import { apiGet, apiPatch } from './client';
import type { AccountLendingType, AccountLendingTypeBatchRequest } from '../types/AccountLendingType';

export function getAccountLendingTypes(): Promise<AccountLendingType[]> {
  return apiGet<AccountLendingType[]>('/api/account-lending-types');
}

export function saveBatchAccountLendingTypes(added: AccountLendingType[], modified: AccountLendingType[], deletedIds: number[]): Promise<AccountLendingType[]> {
  return apiPatch<AccountLendingTypeBatchRequest, AccountLendingType[]>('/api/account-lending-types/batch', { added, modified, deleted: deletedIds });
}
